<div
  #panelElement
  [ngStyle]="customStyles()"
  [attr.aria-labelledby]="titleId"
  role="dialog"
  aria-modal="false"
  tabindex="0"
  class="help-panel"
>
  <!-- The header is the drag handle: a handle on the whole panel would take the pointer before the resize corner. -->
  <div class="help-panel-header" ngpMove (ngpMove)="onMove($event)">
    <h6 [id]="titleId" class="help-panel-title">{{ displayTitle }}</h6>
    <!-- TODO: currently a lot of components are placed in the shared folder and this is not a good practice -->
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close help panel"
      (click)="close()"
    ></sui-button>
  </div>

  <div class="help-panel-content">
    @if (contentState$ | async; as state) {
      @if (state.status === "loading") {
        <div class="loading"></div>
      }

      @if (state.status === "error") {
        <div class="error">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          <div class="message">
            {{ state.error }}
          </div>
        </div>
      }
      @if (state.status === "success") {
        <div class="content" [innerHTML]="state.content"></div>
      }
    }
  </div>
</div>
